// extracted by mini-css-extract-plugin
export default {"temperature_converter_container":"temperature-converter_temperature_converter_container__J8dLO"};